let constData: any = {
  translateIsHandCancelRef: false,
  openQueryAllTranslationRef: false,
  translateDisplayModeRef: undefined,
  translateIsAutoInitialRef: false,
  translateIsLoadingRef: false,
  // setTranslateIsOpen,
  translateIsHandOpenRef: false,
  localTargetLanguageRef: undefined,
  localSourceLanguageRef: undefined,
  watchKeysRef: {
    agendaSummary: false,
    fullSummary: false,
    roleSummary: false,
  },
  translateTagDataRef: undefined,
  reQueryTransTagTimer: null,
  serverTranslateDataStateRef: undefined,
};

const setTransRefData = (key, val) => {
  constData[key] = val;
};

const getTransRefData = (key) => {
  return constData[key];
};
const destroyTransRefData = () => {
  constData = {};
};

export { setTransRefData, getTransRefData, destroyTransRefData };
